import { colors } from '../constants/colors';

export interface InputRangeTheme {
  button: {
    borderRadius?: string;
    paddingMobile: string;
    mobileHeight: string;
    mobileWidth: string;
    padding: string;
    height: string;
    width: string;
  };
  thumb: {
    thumbDiameterMobile: number;
    thumbDiameter: number;
    thumbIcon: boolean;
    thumbColor: string;
    marginTop: number;
  };
  slider: {
    lowerColor: string;
    upperColor: string;
  };
  justifyContent: string;
}

export const inputRange: InputRangeTheme = {
  button: {
    paddingMobile: '0 12px 0 0',
    padding: '0 12px 0 0',
    mobileHeight: '40px',
    mobileWidth: '48px',
    height: '40px',
    width: '48px',
  },
  thumb: {
    thumbColor: colors.jlMoneyGreenDark,
    thumbDiameterMobile: 40,
    thumbDiameter: 40,
    thumbIcon: false,
    marginTop: 0.75,
  },
  slider: {
    lowerColor: colors.jlMoneyGreenDark,
    upperColor: colors.jlMoneyBeige,
  },
  justifyContent: 'space-between',
};
